import "./weather-subtitle";

import { Storybook } from "@tento-ui/ui/storybook";
import { WeatherSubtitle } from "./weather-subtitle";
import { NaiveDate } from "@tento-chrono";
import { WeatherLocations } from "@tento-lona";

export class WeatherSubtitleStoryBook extends Storybook.Default {
  title(): string {
    return "Weather Subtitle";
  }

  examples(): Storybook.Example[] {
    const today = NaiveDate.today();

    return [
      {
        title: "San Francisco (fallback table)",
        render: () => {
          return WeatherSubtitle.makeWith({
            locations: WeatherLocations.FALLBACK,
            lid: WeatherLocations.FALLBACK.all[0].id,
            date: today,
          });
        },
      },
      {
        title: "San Francisco",
        render: () => {
          return WeatherSubtitle.makeWith({
            locations: WeatherLocations.FALLBACK,
            lid: 2487956,
            date: today,
          });
        },
      },
      {
        title: "New York",
        render: () => {
          return WeatherSubtitle.makeWith({
            locations: WeatherLocations.FALLBACK,
            lid: 2459115,
            date: today,
          });
        },
      },
    ];
  }
}
